import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { HelpCircle, Database } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export const QuestionNode = memo(({ data, selected }) => {
  const { isDark } = useTheme();

  return (
    <div className={`w-72 rounded-xl border transition-all ${
      isDark ? 'bg-slate-900 border-slate-800 shadow-xl' : 'bg-white border-slate-200 shadow-lg'
    } ${
      selected ? 'border-sky-500 ring-2 ring-sky-500/30' : (isDark ? 'hover:border-slate-700' : 'hover:border-slate-300')
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className={`!h-3.5 !w-3.5 !border-2 !bg-sky-500 hover:!scale-125 transition-transform ${
          isDark ? '!border-slate-900' : '!border-white'
        }`}
      />

      <div className={`flex items-center justify-between rounded-t-xl px-3.5 py-2.5 border-b ${
        isDark
          ? 'bg-gradient-to-r from-sky-950/80 to-sky-900/40 border-sky-500/20'
          : 'bg-gradient-to-r from-sky-50 to-blue-50 border-sky-200'
      }`}>
        <div className="flex items-center gap-2">
          <div className={`flex h-6 w-6 items-center justify-center rounded-lg ${
            isDark ? 'bg-sky-500/20 text-sky-400' : 'bg-sky-100 text-sky-700'
          }`}>
            <HelpCircle className="h-3.5 w-3.5" />
          </div>
          <span className={`text-xs font-bold uppercase tracking-wider ${
            isDark ? 'text-sky-200' : 'text-sky-900'
          }`}>
            {data.label || 'Ask Question'}
          </span>
        </div>
        <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${
          isDark ? 'bg-sky-500/10 text-sky-300' : 'bg-sky-100 text-sky-700'
        }`}>
          INPUT
        </span>
      </div>

      <div className="p-3.5 space-y-2 text-xs">
        <div className={`font-medium ${isDark ? 'text-slate-300' : 'text-slate-800'}`}>
          {data.question || 'What is your city / preferred location?'}
        </div>

        <div className={`flex items-center gap-1.5 rounded-md px-2 py-1 text-[11px] border ${
          isDark
            ? 'bg-sky-950/40 border-sky-800/40 text-sky-200'
            : 'bg-sky-50 border-sky-200 text-sky-900'
        }`}>
          <Database className="h-3 w-3 text-sky-500 shrink-0" />
          <span className={isDark ? 'text-slate-400' : 'text-slate-500'}>Save to variable:</span>
          <span className="font-mono font-semibold text-sky-500">{data.variable || '(Not set)'}</span>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className={`!h-3.5 !w-3.5 !border-2 !bg-sky-500 hover:!scale-125 transition-transform ${
          isDark ? '!border-slate-900' : '!border-white'
        }`}
      />
    </div>
  );
});
